import { createMasterScreen } from '../../../components/erp/ERPMasterScreenFactory';
export default createMasterScreen({
  title: 'UOM Master', screenId: '4.1.8', module: 'Procurement', apiPath: 'uom', screenName: 'UOMMaster', idField: 'UOmId', nameField: 'UomName',
  gridColumns: [{ field: 'UOmId', header: 'UOM ID' }, { field: 'UomName', header: 'UOM Name' }, { field: 'Convertion_value', header: 'Conversion Value' }],
  formFields: [{ field: 'UOmId', label: 'UOM Id', disabled: true }, { field: 'UomName', label: 'UOM Name', required: true }, { field: 'Convertion_value', label: 'Conversion Value', type: 'number' }]
});
